module.exports = __webpack_public_path__ + "static/img/cross.3f6241c4.svg";